const season = [
  { label: "Spring", value: "1" },
  { label: "Summer", value: "2" },
  { label: "Fall", value: "3" },
  { label: "Winter", value: "4" },
];

export default season;